import bankCardSvg from '@raison/static/icons/bank-card-line.svg';
import mapPinSvg from '@raison/static/icons/map-pin-line.svg';
import userLineSvg from '@raison/static/icons/user-line.svg';
import {useQuery} from '@tanstack/react-query';
import {Getter} from 'jotai';
import {queryClientAtom} from 'jotai-tanstack-query';
import React from 'react';
import {AlertHandler, AlertListWrapper, AlertPane, IAlert} from '~/entities/alerts';
import {UserInfoQueryOptions$, useUserInfoQueryOptions} from '~/entities/user';

export function UserAlertsSection({handlers}: {handlers?: Record<string, AlertHandler<any>>}) {
    const {data: alerts} = useQuery({
        ...useUserInfoQueryOptions(),
        select: data => data.notifications.sort(sortByOptionalDate),
    });

    if (!alerts) {
        return null;
    }

    return <AlertListWrapper alerts={alerts} handlers={{...handlers, ...userAlertHandlersBatch}} />;
}

const userAlertHandlersBatch = AlertHandler.createStaticBatch({
    'kyc-step-required': () => (
        <AlertPane linkTo={`/signup/kyc`} messageSummary={'Some functions are not available'} icon={userLineSvg}>
            {'Verify account to unblock all functions'}
        </AlertPane>
    ),

    'card-operation-awaits-address-verification': () => (
        <AlertPane linkTo={`/address-verification`} messageSummary={'Payment on hold'} icon={bankCardSvg}>
            {'Confirm the address'}
        </AlertPane>
    ),

    'address-verification-required': () => (
        <AlertPane
            linkTo={`/address-verification`}
            messageSummary={'Some functions are not available'}
            icon={mapPinSvg}
        >
            {'Confirm the address to activate more features'}
        </AlertPane>
    ),
});

function sortByOptionalDate(a: {date?: Date | null}, b: {date?: Date | null}) {
    if (!a.date && !b.date) return 0;
    if (!a.date) return 1;
    if (!b.date) return -1;
    return b.date.getTime() - a.date.getTime();
}

export function removeUserAlert(get: Getter, matcher: (alert: IAlert) => boolean) {
    const qc = get(queryClientAtom);
    const {queryKey} = get(UserInfoQueryOptions$);
    qc.setQueryData(queryKey, data => {
        if (!data) {
            return data;
        }
        return {
            ...data,
            notifications: data.notifications.filter(a => !matcher(a)),
        };
    });
}
